<svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="29" height="29" rx="14.5" fill="#F4F4F4"/>
<g clip-path="url(#clip0_90_360)">
<path d="M14.4979 11.9155V3.1571L7.35718 15.2198L14.4979 11.9155Z" fill="#8A92B2"/>
<path d="M14.4979 19.5191V11.9155L7.35718 15.2198L14.4979 19.5191ZM14.4979 11.9155L21.6385 15.2198L14.4979 3.1571V11.9155Z" fill="#62688F"/>
<path d="M14.4978 11.9155V19.5191L21.6385 15.2199L14.4978 11.9155Z" fill="#454A75"/>
<path d="M14.4979 20.896L7.35718 16.6012L14.4979 26.8474V20.896Z" fill="#8A92B2"/>
<path d="M21.6428 16.6012L14.4978 20.896V26.8474L21.6428 16.6012Z" fill="#62688F"/>
</g>
<defs>
<clipPath id="clip0_90_360">
<rect width="15" height="24" fill="white" transform="translate(7 3)"/>
</clipPath>
</defs>
</svg>
